import { NavLink } from 'react-router-dom';
import { Kanban, Map as MapIcon, BarChart3, Users, Package, Plus, LogOut, Settings } from 'lucide-react';
import { cn } from '@/lib/cn';
import { sair } from '@/features/auth/api';

async function handleSair() {
  await sair();
  window.dispatchEvent(new CustomEvent('auth:expirou'));
}

function LeafMark({ size = 22 }: { size?: number }) {
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} fill="var(--moss-300)">
      <path d="M50 86 L 44 64 L 48 50 L 44 30 L 50 8 L 56 30 L 52 50 L 56 64 Z" />
      <path d="M50 86 L 44 70 L 48 56 L 44 38 L 50 18 L 56 38 L 52 56 L 56 70 Z" transform="rotate(-32 50 86)" />
      <path d="M50 86 L 44 70 L 48 56 L 44 38 L 50 18 L 56 38 L 52 56 L 56 70 Z" transform="rotate(32 50 86)" />
      <path d="M50 86 L 44 74 L 48 62 L 44 48 L 50 30 L 56 48 L 52 62 L 56 74 Z" transform="rotate(-62 50 86)" />
      <path d="M50 86 L 44 74 L 48 62 L 44 48 L 50 30 L 56 48 L 52 62 L 56 74 Z" transform="rotate(62 50 86)" />
      <path d="M50 86 L 45 78 L 49 68 L 50 52 L 51 68 L 55 78 Z" transform="rotate(-95 50 86)" />
      <path d="M50 86 L 45 78 L 49 68 L 50 52 L 51 68 L 55 78 Z" transform="rotate(95 50 86)" />
    </svg>
  );
}

const linkBase =
  'inline-flex items-center gap-s3 h-[36px] px-s4 rounded-sm text-[13px] font-semibold text-fg-3 transition-colors duration-fast ease-soft';
const linkActive = 'text-fg-1 bg-card border border-[var(--border-strong)]';
const linkIdle = 'border border-transparent hover:text-fg-1 hover:bg-card';

export function TopBar({ onNovoPedido }: { onNovoPedido?: () => void }) {
  return (
    <header
      className="sticky top-0 z-20 h-[64px] w-full border-b border-[var(--border-subtle)] backdrop-blur-md"
      style={{ background: 'rgba(11,15,13,0.78)' }}
    >
      <div className="h-full w-full px-s7 flex items-center gap-s7">
        <div className="flex items-center gap-s3">
          <LeafMark />
          <div className="flex flex-col leading-none">
            <span className="font-display italic text-[20px] text-fg-1 leading-none">
              Floricultura
            </span>
            <span className="font-body text-[10px] uppercase tracking-[0.2em] text-fg-3 mt-[3px]">
              Noturna
            </span>
          </div>
        </div>

        <nav className="flex items-center gap-s2">
          <NavLink to="/" end className={({ isActive }) => cn(linkBase, isActive ? linkActive : linkIdle)}>
            <Kanban size={16} strokeWidth={1.5} /> Pedidos
          </NavLink>
          <NavLink to="/rotas" className={({ isActive }) => cn(linkBase, isActive ? linkActive : linkIdle)}>
            <MapIcon size={16} strokeWidth={1.5} /> Rotas
          </NavLink>
          <NavLink to="/dashboard" className={({ isActive }) => cn(linkBase, isActive ? linkActive : linkIdle)}>
            <BarChart3 size={16} strokeWidth={1.5} /> Dashboard
          </NavLink>
          <NavLink to="/clientes" className={({ isActive }) => cn(linkBase, isActive ? linkActive : linkIdle)}>
            <Users size={16} strokeWidth={1.5} /> Clientes
          </NavLink>
          <NavLink to="/produtos" className={({ isActive }) => cn(linkBase, isActive ? linkActive : linkIdle)}>
            <Package size={16} strokeWidth={1.5} /> Estoque
          </NavLink>
          <NavLink to="/configuracoes" className={({ isActive }) => cn(linkBase, isActive ? linkActive : linkIdle)}>
            <Settings size={16} strokeWidth={1.5} /> Configurações
          </NavLink>
        </nav>

        <div className="flex-1" />

        <div className="flex items-center gap-s3">
          <button
            onClick={onNovoPedido}
            className="btn-accent inline-flex items-center gap-s3 h-[36px] px-s5 rounded-sm border text-fg-1 text-[13px] font-semibold transition-all duration-fast ease-soft active:scale-[0.98]"
            style={{ boxShadow: 'inset 0 1px 0 rgba(236,235,227,0.04), 0 1px 2px rgba(0,0,0,0.4)' }}
          >
            <Plus size={16} strokeWidth={1.5} /> Novo pedido
          </button>
          <button
            onClick={handleSair}
            title="Sair"
            aria-label="Sair"
            className="inline-flex items-center justify-center h-[36px] w-[36px] rounded-sm border border-transparent text-fg-3 transition-colors duration-fast ease-soft hover:text-fg-1 hover:bg-card"
          >
            <LogOut size={16} strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </header>
  );
}

export default TopBar;
